import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getDataStat} from '../../../apis/analysis/getDataStat'

const useQueryDataStat = () => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.analysis.getDataStat(),
        queryFn: async () => {
            const {data} = await getDataStat()
            return data
        },
    })

    return {data, refetch}
}

export default useQueryDataStat
